import {combineDateTime, toUnixSec} from '../../../../../library/dates';

const FAR_FUTURE = 9999999999;
const FAR_PAST = 0;

export function getLatestOtherTicketsValidityEndUnix(tickets, currentTid) 
{ if(!tickets?.length) return null; 
    return tickets.reduce((maxEnd, ticket) => {
        const v = ticket?.validity;

        if(ticket.tid === currentTid || v?.endDateActive !== 1 || v?.endDate == null) {
            return maxEnd; 
        }
        const end = toUnixSec(v.endDate);
        if(Number.isNaN(end)) return maxEnd; 
        return (maxEnd === null || end > maxEnd) ? end : maxEnd; 
    }, null);
}

function getIntervalFromInput(input, isForm = false) {
    if(!input) return null;

    let start, end;

    if(isForm) {
        const {startDateActive, endDateActive, startDate, startTime, endDate, endTime} = input;
        const hasStart = startDateActive && startDate != null && startTime != null;
        const hasEnd = endDateActive && endDate != null && endTime != null;

        if(!hasStart && !hasEnd) return null;

        start = hasStart ? combineDateTime(startDate, startTime) : FAR_PAST;
        end = hasEnd ? combineDateTime(endDate, endTime) : FAR_FUTURE;
    } else {
        const hasStart = input.startDateActive === 1 && input.startDate != null;
        const hasEnd = input.endDateActive === 1 && input.endDate != null;

        if(!hasStart && !hasEnd) return null;

        start = hasStart ? toUnixSec(input.startDate) : FAR_PAST;
        end = hasEnd ? toUnixSec(input.endDate) : FAR_FUTURE;
    }

    if(
        Number.isNaN(start) ||
        Number.isNaN(end) ||
        (end !== FAR_FUTURE && start !== FAR_PAST && end <= start)
    ) {
        return null;
    }
    return {start, end};
}

function getOtherTicketIntervals(ticket) {
    const v = ticket?.validity;
    if(!v) return [];

    const hasStart = v.startDateActive === 1 && v.startDate != null;
    const hasEnd = v.endDateActive === 1 && v.endDate != null;

    const start = hasStart ? toUnixSec(v.startDate) : null;
    const end = hasEnd ? toUnixSec(v.endDate) : null;

    if(
        Number.isNaN(start) ||
        Number.isNaN(end) ||
        (end !== FAR_FUTURE && start !== FAR_PAST && end <= start)
    ) {
        return [];
    }

    return [{start, end}];
}

function intervalsOverlap(a, b, c, d) {
    const intersectionEnd = Math.min(b, d);
    const intersectionStart = Math.max(a, c);
    const diff = intersectionEnd - intersectionStart;
    return diff > 0;
}

export function getValidityOverlapError(tickets, currentTid, input, t, isForm = false) {
    if(!tickets?.length) return null;

    const current = getIntervalFromInput(input, isForm);
    if(!current) return null;

    for(const ticket of tickets) {
        if(ticket.tid === currentTid) continue;

        const others = getOtherTicketIntervals(ticket);
        for(const other of others) {
            if(intervalsOverlap(current.start, current.end, other.start, other.end)) {
                return t ? t('validityOverlapError') : 'validityOverlapError';
            }
        }
    }
    return null;
}
export function getValidityGapError(tickets, currentTid, input, t, isForm = false) {
    if(!tickets?.length) return null;

    const current = getIntervalFromInput(input, isForm);
    if(!current || current.start === FAR_PAST || current.end === FAR_FUTURE) return null;

    const otherTickets = tickets.filter(tick => tick.tid !== currentTid);
    const intervals = [current];

    for(const tick of otherTickets) {
        const other = getOtherTicketIntervals(tick)[0];
        if(!other || other.start === FAR_PAST || other.end === FAR_FUTURE) return null;
        intervals.push(other);
    }

    intervals.sort((a, b) => a.start - b.start);

    for(let i = 1; i < intervals.length; i++) {
        const prevEnd = intervals[i - 1].end;
        const intervalStart = intervals[i].start;
        if(intervalStart > prevEnd + 1) {
            return t ? t('validityGapError') : 'validityGapError';
        }
    }
    return null;
}

export function getValidityOverlapErrorPayload(tickets, currentTid, validity) {
    return getValidityOverlapError(tickets, currentTid, validity, null, false);
}

export function getValidityGapErrorPayload(tickets, currentTid, validity) {
    return getValidityGapError(tickets, currentTid, validity, null, false);
}

export function getOverlappingTicketNames(tickets, currentTid, validity) {
    if(!tickets?.length) return [];
    const current = getIntervalFromInput(validity, false);
    if(!current) return [];
    const names = [];
    for(const ticket of tickets) {
        if(ticket.tid === currentTid) continue;
        const others = getOtherTicketIntervals(ticket);
        for(const other of others) {
            if(intervalsOverlap(current.start, current.end, other.start, other.end)) {
                if(ticket.title) names.push(ticket.title);
                break;
            }
        }
    }
    return names;
}
